import type { ReactNode } from "react"

export default function InertiaRootLayout({ children }: { children: ReactNode }) {
  return <>{children}</>
}
